module.exports = __webpack_public_path__ + "img/Group 111.918e614f.png";